import {
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  ToastController
} from '@ionic/angular';

import {
  CarritoService
} from 'src/app/servicios/carrito.service';

import {
  environment
} from 'src/environments/environment';


@Component({

  selector: 'app-custom-product-card',

  templateUrl: './custom-product-card.component.html',

  styleUrls: ['./custom-product-card.component.scss'],

  standalone: false

})
export class CustomProductCardComponent
  implements OnInit {


  @Input()
  producto;


  constructor(

    private carritoService: CarritoService,

    private toastController: ToastController

  ) {}


  ngOnInit() {

  }


  // --------------------------------------------------
  // AGREGAR AL CARRITO
  // --------------------------------------------------

  async onClick(event: Event) {

    event.stopPropagation();


    console.log(
      'Producto agregado:',
      this.producto
    );


    this.carritoService.addQuantity(
      this.producto
    );


    const mensaje =
      'Agregado al carrito';


    await this.presentToast(
      mensaje
    );

  }

  obtenerImagen(img: any): string {
    if (!img || img === 'false' || img === '') {
      return 'assets/images/logo-alphan.png';
    }
    const s = String(img);
    if (s.startsWith('assets/') || s.startsWith('http://') || s.startsWith('https://')) {
      return s;
    }
    return `data:image/gif;base64,${s}`;
  }


  // --------------------------------------------------
  // CLUB
  // --------------------------------------------------

  cargaralpha(): boolean {

    return environment.club === 'alpha';

  }


  cargarcimera(): boolean {

    return environment.club === 'cimera';

  }


  cargarsports(): boolean {

    return environment.club === 'sports';

  }


  // --------------------------------------------------
  // TOAST
  // --------------------------------------------------

  async presentToast(msj: string) {

    const toast =
      await this.toastController.create({

        message: msj,

        duration: 1000,

        position: 'bottom'

      });


    toast.present();

  }

}